import React from 'react';
import { Box, Typography, Button } from '@mui/material';

interface FullPageMessageProps {
  headline?: string;
  subHeadline?: string;
  ctaText?: string;
  ctaIcon?: React.ReactNode;
  onCtaClick?: () => void;
  showCta?: boolean;
}

const FullPageMessage: React.FC<FullPageMessageProps> = ({
  headline,
  subHeadline,
  ctaText,
  ctaIcon,
  onCtaClick,
  showCta = true,
}) => {
  return (
    <Box
      className="full-page-message"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="80%"
      textAlign="center"
      sx={{
        minHeight: "80vh"
      }}
    >
      <Typography variant="h1" component="h1" gutterBottom>
        {headline}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {subHeadline}
      </Typography>
      {showCta && ctaText && (
        <Button
          variant="contained"
          color="secondary"
          onClick={onCtaClick}
          endIcon={ctaIcon}
          sx={{ mt: 1 }}
        >
          {ctaText}
        </Button>
      )}
    </Box>
  );
};

export default FullPageMessage;